export const INACTIVE_USER_TIME_THRESHOLD = 3600000
export const USER_ACTIVITY_THROTTLER_TIME = 10000
